<template>
    <div class="academy-historyItem">
        <Anchor :id="'top'" />
        <div class="block mb-16">
            <div class="block-title">
                <div class="dot" />
                {{ $t('academy.landing.title[3]') }}
            </div>
            <ListPagination
                :block-data="History"
                :label-open="false"
                :router-name="'AcademyHistoryItem'"
                :show-data="showData"
            />
        </div>
    </div>
</template>

<script>
import API from '@/api';
import { mapMutations } from 'vuex';
import ListPagination from '@/components/list/ListPagination.vue';

export default {
    components: {
        ListPagination,
    },
    data() {
        return {
            showData: false,
            History: {
                items: null,
            },
        };
    },
    watch: {
        $route() {
            this.init();
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        ...mapMutations('mNotification', ['setAlert', 'handleError']),
        async init() {
            try {
                const res = await API.EducationHistory.PublicList({
                    headers: {
                        'Content-Language': (this.$route.path.split('/')[1] || 'zhTw') === 'en' ? 'en' : 'zhTw',
                    },
                });
                this.History.items = res.data.raw;
                this.showData = true;
            } catch (e) {
                this.handleError({
                    message: e || this.$t('alertMessage.getdata-fail'),
                    color: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss">

</style>
